import { z } from 'zod';
import { DEAL_TYPE_CONFIG } from './constants/deal-types';

export const dealProductSearchParamSchema = z.enum([
  'productId',
  'productName',
]);

export const dealListDealTypeFilterSchema = z.enum([
  DEAL_TYPE_CONFIG.PHYSICAL_GOLD.value,
  DEAL_TYPE_CONFIG.ELECTRONIC.value,
]);

export const viewDealProductsListSearchSchema = z.object({
  page: z.coerce.number().optional(),
  perPage: z.coerce.number().optional(),
  searchParam: dealProductSearchParamSchema.optional(),
  searchValue: z.string().optional(),
  dealType: dealListDealTypeFilterSchema.optional(),
});

export type ViewDealProductsListSearch = z.infer<
  typeof viewDealProductsListSearchSchema
>;

export const dealWizardSearchSchema = z.object({
  step: z.enum(['basic', 'sale', 'description', 'invoice']).optional(),
  id: z.string().optional(),
  dealType: z.string().optional(),
});

export type DealWizardSearch = z.infer<typeof dealWizardSearchSchema>;

export type DealProductSearchParam = z.infer<
  typeof dealProductSearchParamSchema
>;

export type DealListDealTypeFilter = z.infer<
  typeof dealListDealTypeFilterSchema
>;

export const dealDetailParamsSchema = z.object({
  id: z.coerce.string(),
});

export type DealDetailRouteParams = z.infer<typeof dealDetailParamsSchema>;
